<template>
  <div>
    <div v-if="$auth.policies['view-tuition-fee-month']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Đối soát theo tháng"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Đối soát theo tháng', href: '#' }
            ]"
          />
        </div>
      </div>
      <v-card outlined class="mx-4 mb-6 elevation-0">
        <ListMonth />
      </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Page403 from '@/views/Page403.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ListMonth from '../../../modules/tuitionFee/report-month/ListMonth.vue'
import { mapMutations } from 'vuex'

export default {
  components: {
    Page403,
    Breadcrumbs,
    ListMonth
  },
  mounted() {
    this.resetData()
  },
  methods: {
    ...mapMutations({ resetData: 'tuitionFeeReport/resetData' })
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
